module.exports = __webpack_public_path__ + "img/map_z.2558af9d.png";